<template>
  <v-form ref="form">
    <div v-for="(profileLink, index) in profileLinks" :key="index">
      <v-container>
        <v-row align="center" class="justify-space-between mt-0 mb-0">
          <v-col cols="4" class="pt-0 pb-0">
            <v-select
              v-model="profileLink.variety"
              label="リンクタイプ"
              :items="profileLinkTypes"
              item-text="style"
              item-value="value"
            />
          </v-col>
          <v-col cols="6" align="center" class="pt-0 pb-0">
            <v-btn
              color="error"
              outlined
              small
              @click="deleteProfileLink(index)"
            >
              削除
            </v-btn>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" class="mt-0 mb-0">
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field
              v-model="profileLink.linkName"
              label="リンク名(任意)"
              placeholder="公式HP"
            />
          </v-col>
          <v-col cols="6" class="pt-0 pb-0">
            <v-text-field
              v-model="profileLink.url"
              placeholder="https://example.com/user"
              :rules="[presenceValidation, urlValidation]"
              required
            >
              <template v-slot:label>
                <InputLabel labelName="URL" :required="true" />
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-btn class="mt-2 mb-2" outlined color="indigo" @click="addProfileLink">
      リンクを追加する
    </v-btn>
  </v-form>
</template>

<script>
import InputLabel from '@/components/commons/formParts/inputLabel'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'ProfileLinksForm',
  components: {
    InputLabel
  },
  mixins: [formValidationUtils],
  props: {
    profileLinks: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    destroyProfileLinks: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      profileLinkTypes: [
        { style: 'instagram', value: 'instagram' },
        { style: 'twitter', value: 'twitter' },
        { style: 'その他', value: 'other' }
      ]
    }
  },
  methods: {
    addProfileLink () {
      this.profileLinks.push({
        id: null,
        url: null,
        variety: 'other'
      })
    },
    deleteProfileLink (index) {
      this.profileLinks[index]['_destroy'] = true
      this.destroyProfileLinks.push(this.profileLinks[index])
      this.profileLinks.splice(index, 1)
    },
    validate () {
      return this.$refs.form.validate()
    }
  }
}
</script>

<style scoped></style>
